import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { layout } from "@universityofmaryland/web-styles-library";
function createLayoutGridGap({
  columns = 2,
  enableContainerQueries = true,
  alignItems = "start"
} = {}) {
  let gridStyle = layout.grid.gap.two;
  if (columns === 3) gridStyle = layout.grid.gap.three;
  if (columns === 4) gridStyle = layout.grid.gap.four;
  const containerQueryStyles = enableContainerQueries ? {
    containerType: "inline-size"
  } : {};
  const alignmentMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch"
  };
  return new ElementBuilder().styled(gridStyle).withStyles({
    element: {
      [` > *`]: {
        alignSelf: alignmentMap[alignItems],
        ...containerQueryStyles
      }
    }
  }).build();
}
export {
  createLayoutGridGap
};
//# sourceMappingURL=grid-gap.js.map
